import * as React from "react"
import {Footer} from "../components/landingpage/footer";
import {Header} from "../components/header";
import {MetaTags} from "../components/metaTags";
import {Testimonials} from "../components/landingpage/testimonials";

const title = "Feedbacks et témoignages des clients de WealCome";
const metaDescription = "Que ce soit pour de la réalisation de projets, des formations ou encore du coaching individuel approfondi," +
    " nos clients nous ont laissé des feedbacks.";

export default () => {
    return (
        <div>
            <MetaTags title={title} description={metaDescription}/>
            <Header fixedTop={true} backgroundTransition={false}/>
            <div className="main">
                <Testimonials/>
            </div>
            <Footer/>
        </div>
    )
};
